/* eslint-disable react-refresh/only-export-components */
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 [&_svg]:size-3 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
        secondary:
          "border-transparent bg-primary-50 text-primary-800 hover:bg-primary-100",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        outline:
          "border-primary-200 text-primary-800 bg-white/60 backdrop-blur-sm",
        soft:
          "border-transparent bg-cream/80 text-primary-900",
        verified:
          "border-transparent bg-gradient-to-r from-primary-600 to-primary-700 text-white shadow-sm",
        warning:
          "border-transparent bg-amber-100 text-amber-900",
        format:
          "border-transparent bg-primary-50 text-primary-800",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<span className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
